export default "__VITE_ASSET__BHiemzr3__"